import { useCallback } from 'react';
import { IUserPlanPreferences } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { IUserPlanState } from '@/creditflowresearch/application/User/UserPlan/types';
import useGetDefaultPreferences
  from '@/creditflowresearch/application/hooks/userPreferences/useGetDefaultPreferences';

export const useUserPlanPreferences = (
  currentPlan: IUserPlanState,
  setCurrentPlan: React.Dispatch<React.SetStateAction<IUserPlanState>>,
) => {
  const { products = [], regions = [] } = currentPlan || {};
  const getDefaultPreferences = useGetDefaultPreferences(products, regions);
  const preferences = currentPlan?.preferences ?? getDefaultPreferences();

  const hasSavedPreferences = Boolean(currentPlan?.preferences);

  const setUserPlanPreferences = useCallback((preferences: IUserPlanPreferences) => {
    setCurrentPlan((prev) => ({ ...prev, preferences }));
  }, [setCurrentPlan]);

  return {
    preferences,
    hasSavedPreferences,
    setUserPlanPreferences,
  };
};
